<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App',
}
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
 
}



.btn:focus,
.btn:active:focus,
.btn.active:focus,
.btn.focus,
.btn:active.focus,
.btn.active.focus {
    outline: none;
    box-shadow:none;
}
  a {
    color: #595959;
    text-decoration: none;
  }

  a:hover {
    color: #595959;
    text-decoration: none;
  }

  a:link {
    color: #595959;
    text-decoration: none;
  }

  a:active {
    color: #595959;
  }

  a:visited {
    color: #595959;
  }
  .span16{
    font-size: 16px;
  }

</style>



// WEBPACK FOOTER //
// src/App.vue